import React from 'react';
import { StyledTooltip } from './style';

const Tooltip = ({ children, active, onToggle }) => (
  <StyledTooltip active={active} onClick={onToggle} onBlur={onToggle}>
    {children}
  </StyledTooltip>
);

export default Tooltip;
